const tooltips = {
    temppwd: 'A mezőben megadott ideiglenes jelszót az adott felhasználónak az első bejelentkezésekor meg kell változtatnia.',
    email2: 'A mezőben megadott email címnek egyedi értéket kell tartalmaznia.',
    email: 'A mezőben megadott email címhez csak egy felhasználó rögzíthető.',
    felhasznalo: 'Ebben a funkcióban van lehetősége a ROLE_CONFIG_USER_KARB jogosultsággal rendelkező felhasználónak, hogy a többi, a rendszert használó, különböző jogosultsággal rendelkező felhasználónál a rendszer hozzáférés karbantartását elvégezze.',
    csoport: 'Felhasználói csoportokat alakíthatunk ki, amelyek segítségével azonos jogosultságokat tudunk felhasználókhoz rendelni.',
  };
  
  export default function getTooltip(name) {
    return tooltips[name];
  }
  